import { styled } from '@mui/material';
import React from 'react';
import { BudgetBuilderSectionHeader } from 'src/components/BeaconV2Components/ExperimentalLayout/Advertising/BudgetBuilder/common';
import { AdManagerPortfolio } from 'src/types/store/reduxStore';
import { useAppSelector } from 'src/utils/Hooks';
import numeral from 'numeral';

const Row = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  marginBottom: 24
});
const Title = styled('div')({
  fontSize: '14px',
  fontWeight: 700,
  marginBottom: '8px',
  width: 200
});

const Value = styled('div')({
  fontSize: '14px',
  fontWeight: 400,
  marginBottom: '8px'
});

const getAllMtdSpend = (portfolios: any[]) => {
  return portfolios?.reduce((total: number, portfolio: any) => {
    return total + portfolio.mtdSpend;
  }, 0);
};

const getTotalEntityBudget = (portfolios?: any) => {
  return portfolios?.reduce((total: number, portfolio: any) => {
    const currentBudget =
      portfolio?.entity?.extendedAttributes?.newBudgetSetting?.amount ||
      portfolio?.entity?.extendedAttributes?.liveBudgetSetting?.amount ||
      0;
    return total + currentBudget;
  }, 0);
};

const ConfirmationDetail = () => {
  const timeline = useAppSelector((state) => state.adBudgetEditor.timeline);
  const selectedEntity = useAppSelector((state) => state.adBudgetEditor.entity);

  const portfolios = useAppSelector((state) => state.adBudgetEditor.portfolioArray)?.filter(
    (portfolio: AdManagerPortfolio) => {
      return portfolio?.additionalMetaData?.portfolio?.entityId === selectedEntity?.entityId;
    }
  );

  const mtdSpend = getAllMtdSpend(portfolios);
  const totalEntityBudget = getTotalEntityBudget(portfolios);
  const budgetRemaining = totalEntityBudget - mtdSpend;

  // sum portfolio?.additionalValue?.spend_sum_value
  const l30dSpendSum = portfolios?.reduce((total: number, portfolio: any) => {
    return +total + (portfolio?.additionalValues?.spend_sum_value || 0);
  }, 0);

  return (
    <div>
      <BudgetBuilderSectionHeader title="Details" description="" />
      <div className="section_body" style={{}}>
        <Row>
          <Title>Month:</Title>
          <Value>{timeline.displayName}</Value>
        </Row>
        {timeline.name === 'currentMonthBudgetSetting' ? (
          <>
            <Row>
              <Title>Month-to-Date Ad Spend:</Title>
              <Value>{numeral(mtdSpend).format('$1,000')}</Value>
            </Row>
            <Row>
              <Title>Remaining Entity Budget:</Title>
              <Value>{numeral(budgetRemaining).format('$1,000')}</Value>
            </Row>
          </>
        ) : (
            <Row>
              <Title>L30D Ad Spend:</Title>
              <Value>{numeral(l30dSpendSum).format('$1,000')}</Value>
            </Row>
          )}

        <Row>
          <Title>Total Entity Budget:</Title>
          <Value>{numeral(totalEntityBudget).format('$1,000')}</Value>
        </Row>
      </div>
    </div>
  );
};

export default ConfirmationDetail;
